export default {
  data() {
    return {
      showBg: false,
      blur: false,
    };
  },
  computed: {
    bg() {
      return this.coreParams.shop_design.page_background_image_original;
    },
  },
  methods: {
    loadBg() {
      const img = new Image(0, 0);

      img.src = this.bg;
      img.onload = () => {
        this.showBg = true;
      };
    },
  },
  created() {
    if (this.coreParams.shop_design.homepage === 'standard') {
      this.$router.push(this.i18nLink('gallery'));
    } else if (this.coreParams.shop_design.homepage === 'album_list') {
      this.$router.push(this.i18nLink('album'));
    } else if (this.bg) {
      this.loadBg();
    }
  },
};
